<main class="main">
  @if (creature){
  <section class="item animate-fade-scale" [class.animate-in]="animateIn">
    <div class="container">
      <div class="item__inner">
        <div class="item__image">
          <div class="item__image-block">
            <img [src]="creature.imageUrl" alt="itemImage" />
          </div>
        </div>
        <div class="item__content">
          <div class="item__header">
            <div class="item__info">
              <div class="rarity"
                [ngClass]="{'common': creature.rarity == rarityType.Common, 'rare': creature.rarity == rarityType.Rare, 'legendary': creature.rarity == rarityType.Legendary}">
                {{creature.rarity | rarityName | translate}}
              </div>
              <!-- <div class="item__view">
                <div class="item__view-count">
                  <span>
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.99998 4.2031C6.93597 4.2031 6.07117 5.00931 6.07117 6.00031C6.07117 6.99056 6.93597 7.79602 7.99998 7.79602C9.06399 7.79602 9.9296 6.99056 9.9296 6.00031C9.9296 5.00931 9.06399 4.2031 7.99998 4.2031ZM7.99992 8.9137C6.2743 8.9137 4.87109 7.60678 4.87109 6.00032C4.87109 4.39312 6.2743 3.08545 7.99992 3.08545C9.72553 3.08545 11.1295 4.39312 11.1295 6.00032C11.1295 7.60678 9.72553 8.9137 7.99992 8.9137Z"
                        fill="white" />
                      <mask id="mask0_392_9105" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="16" height="12">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H16V12H0V0Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_392_9105)">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.2558 5.99981C2.74381 9.06147 5.25023 10.8818 7.99985 10.8825C10.7495 10.8818 13.2559 9.06147 14.7439 5.99981C13.2559 2.9389 10.7495 1.1186 7.99985 1.11785C5.25103 1.1186 2.74381 2.9389 1.2558 5.99981ZM8.00146 12.0001H7.99826H7.99746C4.68864 11.9978 1.71741 9.83776 0.0486004 6.22025C-0.0162001 6.07942 -0.0162001 5.91997 0.0486004 5.77915C1.71741 2.16238 4.68944 0.00230588 7.99746 7.05514e-05C7.99906 -0.000674559 7.99906 -0.000674559 7.99986 7.05514e-05C8.00146 -0.000674559 8.00146 -0.000674559 8.00226 7.05514e-05C11.3111 0.00230588 14.2823 2.16238 15.9511 5.77915C16.0167 5.91997 16.0167 6.07942 15.9511 6.22025C14.2831 9.83776 11.3111 11.9978 8.00226 12.0001H8.00146Z"
                          fill="white" />
                      </g>
                    </svg>
                  </span>
                  225
                </div>
                <div class="item__view-count">
                  <span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_392_9118)">
                        <path
                          d="M14.7145 2.64623C12.9744 0.906571 10.1436 0.906571 8.40393 2.64623L7.99986 3.05006L7.59603 2.64623C5.85637 0.906335 3.02531 0.906335 1.28565 2.64623C-0.418689 4.35057 -0.429756 7.05212 1.25998 8.93047C2.80114 10.643 7.34643 14.343 7.53928 14.4996C7.6702 14.606 7.82773 14.6578 7.98432 14.6578C7.9895 14.6578 7.99468 14.6578 7.99963 14.6576C8.16163 14.6651 8.32481 14.6096 8.45997 14.4996C8.65282 14.343 13.1986 10.643 14.7402 8.93024C16.4297 7.05212 16.4186 4.35057 14.7145 2.64623ZM13.69 7.98529C12.4884 9.32017 9.18546 12.0733 7.99963 13.0503C6.8138 12.0735 3.51155 9.32065 2.31018 7.98553C1.13142 6.67537 1.12035 4.8095 2.28452 3.64533C2.87908 3.051 3.6599 2.7536 4.44072 2.7536C5.22154 2.7536 6.00236 3.05077 6.59693 3.64533L7.48512 4.53353C7.59085 4.63925 7.72412 4.70236 7.86399 4.72449C8.09099 4.77324 8.33729 4.70989 8.51389 4.53376L9.40256 3.64533C10.5919 2.45644 12.5266 2.45667 13.7152 3.64533C14.8794 4.8095 14.8683 6.67537 13.69 7.98529Z"
                          fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_392_9118">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  100
                </div>
              </div> -->
            </div>
            <h2 class="title item__title">Item #{{creature.nftTokenId}}</h2>
            <p class="item__subtitle">Bee collection</p>
          </div>
          <div class="user">
            <div class="user__header">
              <img src="/assets/image/item/user.svg" alt="user" class="user__image" />
              <div class="user__info">
                <p class="user__owned">{{ 'view_creature.owned_by' | translate }}</p>
                <h3 class="user__name">{{creature.ownerAddress}}</h3>
              </div>
            </div>
            <!-- <div class="user__header user__address">
                <div class="user__address-item">
                  <img src="/assets/image/item/user.svg" alt="user" class="user__image" />
                  <div class="user__info">
                    <p class="user__owned">Renting</p>
                    <h3 class="user__name">Freraand</h3>
                  </div>
                </div>
                <div class="user__address-wallet">
                  <div class="user__owned">Wallet Address</div>
                  <div class="user__name user__wallet">3GUHMnx47raxdKGy...AGHUYH8h1xhFA1P1</div>
                </div>
              </div> -->
            <p class="user__text">Habitant sollicitudin faucibus cursus lectus pulvinar dolor non ultrices
              eget. Facilisi lobortisal morbi fringilla urna amet sed ipsum vitae ipsum malesuada. Habitant
              sollicitudin faucibus cursus lectus pulvinar dolor non ultrices eget. Facilisi lobortisal morbi
              fringilla urna amet sed ipsum</p>
          </div>
          <div class="item__price">
            @if (creature.tradeListing) {
            <div class="item__price-current">{{ 'view_creature.current_price' | translate }}</div>
            <h3 class="item__price-title">
              {{creature.tradeListing.price}} ETH <span>${{creature.tradeListing.price | ethPrice}}</span>
            </h3>
            @if (meIsOwner != undefined && !meIsOwner){
            <button class="button-small" [ngClass]="{'disabled': creature.tradeListing.purchaseStatus != null}"
              [disabled]="creature.tradeListing.purchaseStatus != null" (click)="onBuy($event)">
              @if (creature.tradeListing.purchaseStatus != null){
              Processing...
              } @else {
              {{ 'view_creature.buy_button' | translate }}
              }

            </button>
            }
            }

            @if (meIsOwner != undefined && meIsOwner){
            @if (creature.isAllowForSelling) {
            @if (creature.tradeListing) {
            <div class="item__price-buttons listing">
              <button class="button-small" [ngClass]="{'disabled': creature.tradeListing.purchaseStatus != null}"
                [disabled]="creature.tradeListing.purchaseStatus != null" (click)="showListForSalePopup = true">{{
                'view_creature.change_listing_button' | translate }}</button>
              <div class="button-prompt">
                <button class="button-secondary disabled">{{ 'view_creature.rent_button' | translate }}</button>
                <span class="button-prompt">{{ 'view_creature.cannot_rent_tooltip' | translate }}</span>
              </div>
              <button *ngIf="creature.breedingMaxCount"
                [ngClass]="{'disabled': !creature.isAllowForBreeding || creature.breedingMaxCount == creature.breedingCount}"
                [disabled]="!creature.isAllowForBreeding || creature.breedingMaxCount == creature.breedingCount"
                (click)="showBreedingPopup = true;" class="button-secondary">{{ 'view_creature.breed_button' | translate
                }}</button>
              <!-- <button class="button-secondary" (click)="showBreedingPopup = true;">Breed</button> -->
              <!-- <button class="button-secondary">Gift</button> -->
            </div>
            } @else {
            <div class="item__price-buttons listing">
              <button class="button-small" (click)="showListForSalePopup = true">{{ 'view_creature.sell_button' |
                translate }}</button>
              <button class="button-secondary disabled">{{ 'view_creature.rent_button' | translate }}</button>
              <button *ngIf="creature.breedingMaxCount"
                [ngClass]="{'disabled': !creature.isAllowForBreeding || creature.breedingMaxCount == creature.breedingCount}"
                [disabled]="!creature.isAllowForBreeding || creature.breedingMaxCount == creature.breedingCount" (click)="showBreedingPopup = true;"
                class="button-secondary">{{ 'view_creature.breed_button' | translate }}</button>
              <!-- <button class="button-secondary" (click)="showBreedingPopup = true;">Breed</button> -->
              <!-- <button class="button-secondary">Gift</button> -->
            </div>
            }
            }
            }
          </div>
          <!-- <div class="item__price">
              <div class="item__price-rent">
                <div class="item__price-discount">
                  <div class="item__price-fee"><img src="/assets/image/item/icn_coin.svg" alt="Coin">Fee</div>
                  <div class="item__price-percent">25 %</div>
                </div>
                <div class="item__price-discount">
                  <div class="item__price-fee"><img src="/assets/image/item/icn_crystal.svg" alt="Crystal">Fee</div>
                  <div class="item__price-percent">10 %</div>
                </div>
              </div>
              <button class="button-small">Apply to rent</button>
              <button class="button-small">Edit Rent</button>
              <button class="button-small">Return creature</button>

              <div class="item__price-buttons">
                <button class="button-small long">Edit Rent</button>
                <button class="button-secondary">View Offers</button>
              </div>
            </div> -->
          <!-- <div class="item__renting">
              <h3 class="item__renting-title">Renting info</h3>
              <ul class="item__renting-list">
                <li>Renting time <span>30 days</span></li>
                <li>Breeding <span>Unlocked</span></li>
                <li>Card reshuffle <span>Locked</span></li>
              </ul>
            </div> -->
          <div class="item__technical">
            <h3 class="item__technical-title">{{ 'view_creature.technical.title' | translate }}</h3>
            <ul class="item__technical-list">
              <li>{{ 'view_creature.technical.creature_id' | translate }} <span>{{creature.nftTokenId}}</span></li>
              <li>{{ 'view_creature.technical.blockchain' | translate }} <span>{{blockchain}}</span></li>
              <li>{{ 'view_creature.technical.breeding_info' | translate }} <span>{{creature.breedingParents.length == 0
                  ? 'Parent' : 'Child'}}</span></li>
              <li>{{ 'view_creature.technical.creature_type' | translate }} <span>{{creature.type | creatureType |
                  translate}}</span></li>
              <li>{{ 'view_creature.technical.creature_rarity' | translate }} <span>{{creature.rarity | rarityName |
                  translate}}</span></li>
              <li *ngIf="creature.breedingMaxCount">{{ 'view_creature.technical.breed_count' | translate }}
                <span>{{creature.breedingCount}}/{{creature.breedingMaxCount}}</span>
              </li>
              <li *ngIf="creature.nextBreedingAt && !creature.isAllowForBreeding">{{
                'view_creature.technical.next_breeding' | translate }} <span> {{ (creature.nextBreedingAt |
                  dateToSecondsLeft) | countdown }}</span></li>
            </ul>
          </div>
          <div class="item__ability">
            <h3 class="item__ability-title">{{ 'view_creature.ability_cards.title' | translate }}</h3>
            <div class="item__ability-inner">
              <div class="item__ability-card" *ngFor="let ability of creature.abilities">
                <img [src]="ability.imageUrl ? ability.imageUrl : '/assets/image/item/oregon.svg'" [alt]="ability.name"
                  class="item__ability-image">
                <div class="item__ability-info">
                  <div class="rarity"
                    [ngClass]="{'common': ability.rarity == rarityType.Common, 'rare': ability.rarity == rarityType.Rare, 'legendary': ability.rarity == rarityType.Legendary}">
                    {{ability.rarity | rarityName | translate}}</div>
                  <h4 class="item__ability-name">{{ability.nameTranslations ? ability.nameTranslations[lang!] :
                    ability.name}}</h4>
                  <p class="item__ability-text">{{ability.descriptionTranslations ?
                    ability.descriptionTranslations[lang!] : ability.description}}</p>
                  <div class="item__ability-damage">
                    @for (phase of ability.phases; track $index) {
                    <span *ngFor="let applicator of phase.applicators">
                      @if (applicator.damageType != abilityDamageType.Heal){
                      {{applicator.min}} - {{applicator.max}} {{ 'view_creature.ability_cards.damage' | translate }}
                      } @else {
                      {{applicator.min}} - {{applicator.max}} {{ 'view_creature.ability_cards.heal' | translate }}
                      }
                      <br></span>
                    }

                    <!-- <br> 11-50% 15 damage,
                    <br>51-80% 10 damage,<br> 81-100% 5 damage -->
                  </div>
                </div>
              </div>
              <!-- <div class="item__ability-card">
                <img src="/assets/image/item/zunny.svg" alt="zunny" class="item__ability-image">
                <div class="item__ability-info">
                  <div class="rarity common">Common</div>
                  <h4 class="item__ability-name">Name</h4>
                  <p class="item__ability-text">Deal damage to an enemy, lower is the health of you creature more
                    damage bonus this attack will do.</p>
                  <div class="item__ability-damage"><span>0-10% - 20 damage,</span> <br> 11-50% 15 damage,
                    <br>51-80% 10 damage,<br> 81-100% 5 damage
                  </div>
                </div>
              </div>
              <div class="item__ability-card">
                <img src="/assets/image/item/sharkman.svg" alt="Sharkman" class="item__ability-image">
                <div class="item__ability-info">
                  <div class="rarity legendary">Legendary</div>
                  <h4 class="item__ability-name">Name</h4>
                  <p class="item__ability-text">Deal damage to an enemy, lower is the health of you creature more
                    damage bonus this attack will do.</p>
                  <div class="item__ability-damage"><span>0-10% - 20 damage,</span> <br> 11-50% 15 damage,
                    <br>51-80% 10 damage,<br> 81-100% 5 damage
                  </div>
                </div>
              </div>
              <div class="item__ability-card">
                <img src="/assets/image/item/moonbit.svg" alt="Moonbit" class="item__ability-image">
                <div class="item__ability-info">
                  <div class="rarity rare">Rare</div>
                  <h4 class="item__ability-name">Name</h4>
                  <p class="item__ability-text">Deal damage to an enemy, lower is the health of you creature more
                    damage bonus this attack will do.</p>
                  <div class="item__ability-damage"><span>0-10% - 20 damage,</span> <br> 11-50% 15 damage,
                    <br>51-80% 10 damage,<br> 81-100% 5 damage
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="item__history" *ngIf="salesHistory && salesHistory.length > 0">
            <h3 class="item__history-title">{{ 'view_creature.sales_history.title' | translate }}</h3>
            <div class="item__history-list">
              <div class="item__history-item" *ngFor="let sales of salesHistory">
                <div class="item__history-left">
                  <img class="item__history-image" src="/assets/image/item/user.svg" alt="User">
                  <div class="item__history-info">
                    <h4 class="item__history-name"> {{sales.sellerAddress}} <span>{{
                        'view_creature.sales_history.place_bid' | translate }}</span></h4>
                    <div class="item__history-time" [title]="sales.buyghtAt"><span>{{
                        'view_creature.sales_history.place_bid' | translate }}</span>{{sales.buyghtAt! |
                      timeAgo}}</div>
                  </div>
                </div>
                <div class="item__history-right">
                  <h4 class="item__history-pol">{{sales.price}} ETH</h4>
                  <div class="item__history-price">${{sales.price | ethPrice}}</div>
                </div>
              </div>
            </div>
          </div>


          <div class="item__parents" *ngIf="parentCreatures && parentCreatures.length > 0">
            <h3 class="item__parents-title">{{ 'view_creature.parents.title' | translate }}</h3>
            <div class="list__inner">
              @for (parentCreature of parentCreatures; track parentCreature) {
              <div class="list__item">
                <div class="list__card">
                  <a [routerLink]="['/', lang, 'marketplace','view', parentCreature.id]">
                    <item-creature-component [creature]="parentCreature"></item-creature-component>
                  </a>
                </div>
              </div>
              }
              <!-- <div class="list__item">
                <div class="list__card">
                  <a href="">
                    <div class="list__card-rarity rarity common">Common</div>
                    <img class="list__card-img" src="/assets/image/list/person1.png" alt="person1" />
                    <div class="list__card-info">
                      <div class="list__card-left">
                        <div class="list__card-name">Moon-Bits</div>
                        <div class="list__card-id">00036</div>
                        <div class="list__card-time">48 min ago</div>
                      </div>
                      <div class="list__card-right">
                        <div class="list__card-score">#124/3000</div>
                        <div class="list__card-pol">9.52 <span>ETH</span></div>
                        <div class="list__card-price">525.77 USD</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="list__item">
                <div class="list__card">
                  <a href="">
                    <div class="list__card-rarity rarity rare">Rare</div>
                    <img class="list__card-img" src="/assets/image/list/person2.png" alt="person2" />
                    <div class="list__card-info">
                      <div class="list__card-left">
                        <div class="list__card-name">Moon-Bits</div>
                        <div class="list__card-id">00036</div>
                        <div class="list__card-time">48 min ago</div>
                      </div>
                      <div class="list__card-right">
                        <div class="list__card-score">#124/3000</div>
                        <div class="list__card-pol">9.52 <span>ETH</span></div>
                        <div class="list__card-price">525.77 USD</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div> -->
            </div>
          </div>

           <div class="item__parents" *ngIf="childCreatures && childCreatures.length > 0">
            <h3 class="item__parents-title">{{ 'view_creature.children.title' | translate }}</h3>
            <div class="list__inner">
              @for (childCreature of childCreatures; track childCreature) {
              <div class="list__item">
                <div class="list__card">
                  <a [routerLink]="['/', lang, 'marketplace','view', childCreature.id]">
                    <item-creature-component [creature]="childCreature"></item-creature-component>
                  </a>
                </div>
              </div>
              }
            </div>
          </div>


        </div>
      </div>
    </div>
  </section>
  <section class="list item-list" *ngIf="relatedCreatures && relatedCreatures.length > 0">
    <div class="container mob">
      <div class="list__header">
        <h2 class="title">{{ 'view_creature.related.title' | translate }}</h2>
      </div>
      <div class="list__inner">
        @for (relatedCreature of relatedCreatures; track relatedCreature) {
        <div class="list__item">
          <div class="list__card">
            <a [routerLink]="['/', lang, 'marketplace','view', relatedCreature.id]">
              <item-creature-component [creature]="relatedCreature"></item-creature-component>
            </a>
          </div>
        </div>
        }
      </div>
      <div class="list__swiper swiper">
        <div class="swiper-wrapper">
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person1.png" alt="person1" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person1.png" alt="person1" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity rare">Rare</div>
            <img class="list__card-img" src="/assets/image/list/person2.png" alt="person2" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity legendary">Legendary</div>
            <img class="list__card-img" src="/assets/image/list/person3.png" alt="person3" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person4.png" alt="person4" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person5.png" alt="person5" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person6.png" alt="person6" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person1.png" alt="person1" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity rare">Rare</div>
            <img class="list__card-img" src="/assets/image/list/person2.png" alt="person2" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity legendary">Legendary</div>
            <img class="list__card-img" src="/assets/image/list/person3.png" alt="person3" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person4.png" alt="person4" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person5.png" alt="person5" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
          <a href="" class="list__card swiper-slide">
            <div class="list__card-rarity rarity common">Common</div>
            <img class="list__card-img" src="/assets/image/list/person6.png" alt="person6" />
            <div class="list__card-info">
              <div class="list__card-left">
                <div class="list__card-name">Moon-Bits</div>
                <div class="list__card-id">00036</div>
                <div class="list__card-time">48 min ago</div>
              </div>
              <div class="list__card-right">
                <div class="list__card-score">#124/3000</div>
                <div class="list__card-pol">9.52 <span>ETH</span></div>
                <div class="list__card-price">525.77 USD</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section class="popup-container">
    @if (showBreedingPopup){
    <breeding-creature-popup [creatureRef]="creature" [(show)]="showBreedingPopup"></breeding-creature-popup>
    }
    @else if (showListForSalePopup){
    <list-for-sell-creature-popup [creatureRef]="creature"
      [(show)]="showListForSalePopup"></list-for-sell-creature-popup>
    }
  </section>
  <section *ngIf="showLoading" class="loader-box">
    <span class="loader"></span>
  </section>
  } @else {
  <section class="item loading">
    <div class="container">
      <span class="loader"></span>
    </div>
  </section>
  }
</main>